<template>
	<Base :path="white ? 'jon-white.svg' : 'jon.svg'" alt="Jon" />
</template>

<script>
import Base from "./Base";

export default {

	components: {Base},

	props: {
		white: {
			type: Boolean,
			required: false,
			default: false
		}
	}
}
</script>
